export const sortingValues = {
  fastest: 'fastest',
  cheapest: 'cheapest',
  custom: 'custom',
}

export const sortingTypes = [
  { label: 'Más rápido', value: sortingValues.fastest },
  { label: 'Más barato', value: sortingValues.cheapest },
  { label: 'Personalizada', value: sortingValues.custom },
]
